import type { FC } from 'react';
import Button from '@components/Button';
import Tooltip from '@components/Tooltip';
import type { PPLSyncStatus } from '@root/@types/types';
import clsx from 'clsx';
import dayjs from 'dayjs';

import { getButtonProps } from '../utils/get-button-props';

interface SyncDataButtonProps {
  isDisabled: boolean;
  isLoading: boolean;
  lastSyncedAt?: string;
  onClick: () => void;
  syncStatus?: PPLSyncStatus;
}

const formatTooltipContent = (lastSyncedAt?: string) => {
  if (!lastSyncedAt) {
    return '';
  }

  const relativeTime = dayjs().to(dayjs(lastSyncedAt));
  return `Last synced ${relativeTime}`;
};

export const SyncDataButton: FC<SyncDataButtonProps> = ({
  isDisabled,
  isLoading,
  lastSyncedAt,
  onClick,
  syncStatus,
}) => {
  const { icon, text, ...buttonProps } = getButtonProps(syncStatus, isLoading, isDisabled);

  return (
    <Tooltip content={formatTooltipContent(lastSyncedAt)} placement="bottom">
      <div>
        <Button
          {...buttonProps}
          className={clsx(buttonProps.className, 'h-[34px]')}
          isDisabled={isLoading || isDisabled}
          size="sm"
          onClick={() => onClick()}
        >
          {icon}
          {text}
        </Button>
      </div>
    </Tooltip>
  );
};
